export const mapInitialToGender = {
  B: 'Both',
  F: 'Women',
  M: 'Men'
};
